import ViewModal from 'Shared/ViewModal/ViewModal'
import { Button } from 'reactstrap'
import FontAwesomeIcon from 'Shared/FontAwesomeIcon/FontAwesomeIcon'
import Loading from 'Shared/Loading'
import terminalInsertCard from 'Shared/Assets/terminal_insert_card'
import 'POS/Containers/Checkout/Terminal.scss'

const TerminalStepsModal = ({ creatingReservation, error, errors, insertCardNow, isConnected, modalText, onClose,
                              onCloseWithRetry, processingPayment, show, toggle }) => {
  const errorsPresent = error?.length || !!Object.keys(errors || {}).length
  const stateProcessing = processingPayment || creatingReservation
  const stepText = stateProcessing ? 'Processing Payment' : modalText
  const showRetry = !isConnected && error !== 'Could not find registered reader.'

  const getModalContent = () => {
    if (errorsPresent)
      return (
        <>
          <FontAwesomeIcon color="red" icon="triangle-exclamation" size="2xl" />

          <p className="fw-bold text-danger text-lg mt-1">Transaction Error</p>

          <p className="text-gray text-center">
            {error} {Object.values(errors).join(', ')} <br />
            Please try again.
          </p>

          {showRetry && <Button block className="mt-auto" color="salmon" onClick={onCloseWithRetry}>Retry</Button>}
        </>
      )

    if (insertCardNow)
      return (
        <>
          <span className="fw-bold mb-4">Please tap, swipe or insert Credit Card</span>

          <img alt="Stripe Insert Card" className="terminal-img" src={terminalInsertCard} />
        </>
      )

    if (!stateProcessing && !insertCardNow && !errorsPresent)
      return <Loading className="mb-3 d-flex justify-content-center" iconClass="text-salmon" />

    return (
      <>
        <Loading className="mb-3 d-flex justify-content-center" iconClass="text-salmon" />

        <span className="fw-bold">{stepText}</span>

        <span className="text-muted">Do not close or refresh this window!</span>
      </>
    )
  }

  return (
    <ViewModal className="terminal-modal" isOpen={show} onClosed={onClose} preventClosing={stateProcessing}
               showCloseIcon={!!errorsPresent || insertCardNow} showOkButton={false} size="md"
               title="Pay with Terminal" toggle={toggle}>
      <div className="d-flex flex-column align-items-center">
        {getModalContent()}
      </div>
    </ViewModal>
  )
}


export default TerminalStepsModal
